import { FluidExpandedPosition, FluidRowData } from '@lmig/fluid-core';
import { h } from '@stencil/core';

import { ID } from '../../../constants/constants';
import { Utils } from '../../../utils/utils';
import {
  addFormReference,
  handleFormUpdate,
  handleValueChange,
} from '../internal/fluid-table-form.utils';

export type TableFormProps = {
  formExpanded: boolean;
  host: any;
  dataItem: FluidRowData;
  visible: boolean;
  allowTabIndexRows: boolean;
  allowTabIndexCells: boolean;
  expandedButtonPosition: FluidExpandedPosition;
  colSpan: number;
  isActionColumnDisplayed: boolean;
};

export const TableForm = (props: TableFormProps) => {
  const {
    formExpanded,
    host,
    dataItem,
    visible,
    allowTabIndexRows,
    allowTabIndexCells,
    expandedButtonPosition,
    colSpan,
    isActionColumnDisplayed,
  } = props;
  const rowClass = {
    'expand-form': true,
    expanded: formExpanded && visible,
  };

  const formInstanceConfig = host._editableForms[dataItem.rowId]?.config || {
    ...host.expandableForm,
    elements: [...host.expandableForm.elements.map((el) => ({ ...el }))],
  };

  return (
    <tr class={rowClass} tabIndex={Utils.setTabIndex(allowTabIndexRows)}>
      {expandedButtonPosition === FluidExpandedPosition.LEFT && (
        <td class='highlight' />
      )}
      <td
        class='form'
        tabIndex={Utils.setTabIndex(allowTabIndexCells)}
        colSpan={colSpan}>
        <fluid-form
          config={{ ...formInstanceConfig, formName: dataItem[ID] }}
          fromData={dataItem}
          ref={(el) => addFormReference(host, dataItem.rowId, el)}
          onValueChanged={(value: CustomEvent) =>
            handleValueChange(host, value.detail, dataItem)
          }
          onFormChanged={(value: CustomEvent) =>
            handleFormUpdate(host, value.detail, dataItem)
          }
        />
      </td>
      {expandedButtonPosition === FluidExpandedPosition.RIGHT && (
        <td class='highlight' />
      )}
      {isActionColumnDisplayed && <td />}
    </tr>
  );
};
